import {
  type Connection,
  useManagedAuthEnforcement,
  useQueryManagedGuards,
} from "@zapier/client";

/** Whether the managed-app guard blocks sharing or re-authing this connection for the current user. */
export function useManagedConnectionBlocks(connection: Connection | undefined) {
  const {
    isAppShareRestricted,
    isAppReconnectRestricted,
    isLoading: isGuardsLoading,
  } = useQueryManagedGuards();
  const { isManagedAuthEnforced, isLoading: isEnforcementLoading } =
    useManagedAuthEnforcement();

  const isPersonal = !!connection && !connection.isManaged;
  const appId = connection?.selectedApi ?? "";
  const isEnforced = isPersonal && isManagedAuthEnforced;

  return {
    isShareBlocked: isEnforced && isAppShareRestricted(appId),
    isReconnectBlocked: isEnforced && isAppReconnectRestricted(appId),
    isLoading: isPersonal && (isGuardsLoading || isEnforcementLoading),
  };
}
